import React from 'react'
import Helmet from 'react-helmet'
import { backendURL } from '../../data/config.json'

//Components
import Fleet from '../../components/Fleet'

const EconomicEs = props => (
  <div className="page Economic">
  <Helmet
          title={`Vehículos Económicos para alquilar | Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Preguntas frecuentes sobre el alquiler de autos.',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'es',
              href:
                './en/fleet/economic',
            },
          ]}
        />
    <h1>Económico</h1>
    <Fleet
      lang={props.pathContext.langKey}
      types={props.data.dataJson.fleetTypes}
      fleet={props.data.dataJson.fleet}
      features={props.data.dataJson.fleetFeatures}
      category={9}
    />
  </div>
)

export const query = graphql`
  query EconomicES {
    dataJson(id: { regex: "/fleet/" }) {
      ...FleetData
    }
    allFile(filter: { relativeDirectory: { eq: "fleet" } }) {
      edges {
        node {
          name
          childImageSharp {
            resolutions {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`

export default EconomicEs



// WEBPACK FOOTER //
// ./src/pages/fleet/economic.es.js